import { render, staticRenderFns } from "./EduGallery.vue?vue&type=template&id=1a948214&"
import script from "./EduGallery.vue?vue&type=script&lang=js&"
export * from "./EduGallery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports